<div class="languageChooser">
    <mat-form-field>
        <mat-label>{{'Language' | translate}}</mat-label>
        <mat-select [(ngModel)]="currentLanguage" (selectionChange)="changeLanguage($event)">
            @for(lang of availableLanguages; track lang) {
                <mat-option [value]="lang">{{lang}}</mat-option>
            }
        </mat-select>
    </mat-form-field>

</div>
